/**
 * Build-time branding configuration.
 * Controlled by VITE_APP_VARIANT env var at build time.
 * Default: 'fleettracko' (no change to existing behavior).
 *
 * Mirrors apps/fleet-web/src/config/branding.ts.
 */

export interface BrandConfig {
  name: string;
  short: string;
  tagline: string;
  version: string;
  colors: {
    primary: Record<string, string>;
  };
}

const version = import.meta.env.VITE_APP_VERSION || 'dev';

const brands: Record<string, BrandConfig> = {
  fleettracko: {
    name: 'FleetTracko',
    short: 'FT',
    tagline: 'Compound Operations',
    version,
    colors: {
      // Current admin purple palette — keeps the default visually identical.
      primary: {
        50: '#faf5ff',
        100: '#f3e8ff',
        200: '#e9d5ff',
        300: '#d8b4fe',
        400: '#c084fc',
        500: '#a855f7',
        600: '#9333ea',
        700: '#7c3aed',
        800: '#6b21a8',
        900: '#581c87',
        950: '#3b0764',
      },
    },
  },
  hubmotion: {
    name: 'Hubmotion',
    short: 'HM',
    tagline: 'Compound Operations',
    version,
    colors: {
      primary: {
        50: '#ebfdff',
        100: '#d0f9ff',
        200: '#a5f2ff',
        300: '#67e9fe',
        400: '#02eefc',
        500: '#00cdef',
        600: '#00b6ed',
        700: '#0092c4',
        800: '#00739c',
        900: '#045d80',
        950: '#063a52',
      },
    },
  },
};

const variant = (import.meta.env.VITE_APP_VARIANT as string) || 'fleettracko';

export const branding: BrandConfig = brands[variant] || brands.fleettracko;
